<section
  id="app-table"
  class="table-container p-0 my-3 overflow-scrool"
  [class.overflow-x-scroll]="!removeScrool"
>
  <table class="table table-bordered" *ngIf="data">
    <thead>
      <tr>
        <ng-container
          *ngTemplateOutlet="
            header || defaultHeaderTemplate;
            context: { $implicit: data }
          "
        >
        </ng-container>
        <th
          scope="col"
          *ngIf="
            data?.length &&
            (showDefaultActionButton || showDropdownActionButton)
          "
        >
          Ações
        </th>
      </tr>
    </thead>
    <tfoot></tfoot>
    <tbody>
      <tr
        *ngFor="
          let item of data
            | paginate
              : {
                  id: 'server',
                  itemsPerPage: totalPerPage,
                  currentPage: page,
                  totalItems: totalItems,
                }
        "
      >
        <ng-container
          *ngTemplateOutlet="
            items || defaultRowTemplate;
            context: { $implicit: item }
          "
        >
        </ng-container>
        <td *ngIf="showDefaultActionButton">
          <div class="d-flex justify-content-between">
            <i
              *ngIf="canEdit"
              class="bx bxs-edit-alt"
              (click)="update(item)"
            ></i>
            <i
              *ngIf="canDelete"
              class="bx bx-trash-alt"
              (click)="remove(item)"
            ></i>
          </div>
        </td>

        <td *ngIf="showDropdownActionButton && item.actions">
          <div>
            <button
              type="button"
              class="btn btn-outline-secondary-person action-button m-1 z-100"
              id="dropdownManual"
              (click)="myDrop.open()"
            >
              <i class="mdi mdi-dots-vertical"></i>
            </button>

            <div ngbDropdown #myDrop="ngbDropdown">
              <div ngbDropdownMenu aria-labelledby="dropdownManual">
                <button
                  *ngFor="let action of item.actions"
                  (click)="action.action(item)"
                  ngbDropdownItem
                  class="z-3"
                >
                  {{ action.title }}
                </button>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot *ngIf="!showFooterLabel">
      <tr>
        <td colspan="20">
          <div class="text-md-right float-md-end pagination-rounded">
            <pagination-controls
              id="server"
              directionLinks="true"
              autoHide="true"
              responsive="true"
              previousLabel=""
              nextLabel=""
              (pageChange)="pageChangeEvent.emit($event)"
            ></pagination-controls>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
  <div
    class="col-md-12 d-flex align-items-center h-50 justify-content-center"
    *ngIf="!data?.length"
  >
    <span class="text-secondary">{{ emptyMessage }}</span>
  </div>
</section>

<div
  class="d-flex justify-content-between align-items-center w-100 pagination-action"
  *ngIf="showFooterLabel"
>
  <div class="text-left">
    Mostrando de <span style="font-weight: bold">{{ startItem }}</span> ao
    <span style="font-weight: bold">{{ endItem }}</span> de
    <span style="font-weight: bold">{{ totalItems }}</span> registros
  </div>
  <div class="flex-grow-1"></div>
  <div class="pagination-rounded">
    <pagination-controls
      id="server"
      directionLinks="true"
      autoHide="true"
      previousLabel=""
      nextLabel=""
      (pageChange)="pageChangeEvent.emit($event)"
    ></pagination-controls>
  </div>
</div>

<ng-template #defaultRowTemplate let-item>
  <td *ngFor="let item of item | keyvalue">{{ item.value }}</td>
</ng-template>

<ng-template #defaultHeaderTemplate let-data>
  <th *ngFor="let header of data[0] | keyvalue">{{ header.key }}</th>
</ng-template>
